import React from "react";
import OrdersTable from "./OrdersTable";

const AllOrders = () => {
  return <OrdersTable type="All" title="All Orders" />;
};

export default AllOrders;
